import { render } from "./ProjectVendorStep.vue?vue&type=template&id=86a52288"
import script from "./ProjectVendorStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectVendorStep.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Admin/Project/ProjectVendorStep.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "86a52288"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('86a52288', __exports__)) {
    api.reload('86a52288', __exports__)
  }
  
  module.hot.accept("./ProjectVendorStep.vue?vue&type=template&id=86a52288", () => {
    api.rerender('86a52288', render)
  })

}


export default __exports__